<template>
  <div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h3 class="text-dark">Tunesoft</h3>
                      <h5 class="text-primary">
                        {{ $t("account.activation-text") }}
                      </h5>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-light">
                      <img :src="whiteLabel || require('@/assets/images/logo-small.png')" height="34" />
                    </span>
                  </div>
                </div>
                <div class="p-2">
                  <p class="text-muted">
                    {{ $t("account.activation-description") }}
                  </p>

                  <b-button @click="activate" block variant="primary">
                    <i class="bx font-size-24 align-middle mr-2" :class="isRequesting ? 'bx-loader bx-spin' : 'bx-check-shield'"></i>
                    {{ $t("account.activation-activate") }}
                  </b-button>
                </div>
              </div>
            </div>
            <div class="mt-5 text-center">
              <p>
                <router-link to="/login" class="font-weight-medium text-primary">
                  <i class="bx bx-lock font-size-16 align-middle"></i>

                  {{ $t("account.login-text") }}
                </router-link>
              </p>
              <p>© {{ new Date().getFullYear() }} Tunesoft</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isRequesting: false,
      form: {
        token: this.$route.params.token,
      },
    };
  },

  mounted() {
    this.token = this.$route.params.token;
  },
  methods: {
    async activate() {
      try {
        if (this.isRequesting) {
          return;
        }
        this.isRequesting = true;
        await this.$store.dispatch("user/activate", this.form);
        this.$toast.success(this.$t("common.activate-account"));

        setTimeout(() => {
          this.isRequesting = false;
          window.location.href = "/login";
        }, 2000);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
        this.isRequesting = false;
      }
    },
  },
};
</script>
